import React, { useState, useRef, useEffect } from 'react';
import { ApiCore } from '../../api/index';
import { Toast, TextArea, Modal } from 'antd-mobile-v5';
import reporting_body from '../../static/images_ae/reporting/reporting_body.png';
import area_head from '../../static/images_ae/reporting/area_head.png';
import line_head from '../../static/images_ae/reporting/line_head.png';
import area_chest from '../../static/images_ae/reporting/area_chest.png';
import line_chest from '../../static/images_ae/reporting/line_chest.png';
import area_stomach from '../../static/images_ae/reporting/area_stomach.png';
import line_stomach from '../../static/images_ae/reporting/line_stomach.png';
import area_others from '../../static/images_ae/reporting/area_others.png';
import line_others from '../../static/images_ae/reporting/line_others.png';
import line_heart from '../../static/images_ae/reporting/line_heart.png';
import line_lungs from '../../static/images_ae/reporting/line_lungs.png';
import line_blood from '../../static/images_ae/reporting/line_blood.png';
import line_skin from '../../static/images_ae/reporting/line_skin.png';
import line_weight from '../../static/images_ae/reporting/line_weight.png';
import line_skeleton from '../../static/images_ae/reporting/line_skeleton.png';
import area_four_limbs from '../../static/images_ae/reporting/area_four_limbs.png';
import line_four_limbs from '../../static/images_ae/reporting/line_four_limbs.png';
import tip_top_select from '../../static/images_ae/reporting/tip_top_select.png';
import sympton_bg from '../../static/images_ae/reporting/sympton_bg.png';
import bg_back from '../../static/images_ae/reporting/bg_back.png';
import bg_finish_go_on from '../../static/images_ae/reporting/bg_finish_go_on.png';
import tip_bottom_select from '../../static/images_ae/reporting/tip_bottom_select.png';
import organ_heart from '../../static/images_ae/reporting/organ_heart.png';
import organ_lung from '../../static/images_ae/reporting/organ_lung.png';
import organ_blood from '../../static/images_ae/reporting/organ_blood.png';
import organ_skin from '../../static/images_ae/reporting/organ_skin.png';
import orgran_skeleton from '../../static/images_ae/reporting/orgran_skeleton.png';
import organ_weight from '../../static/images_ae/reporting/organ_weight.png';
import organ_blood_blue from '../../static/images_ae/alkReport/organ_blood_blue.png';
import organ_blood_purple from '../../static/images_ae/alkReport/organ_blood_purple.png';
import organ_body_blue from '../../static/images_ae/alkReport/organ_body_blue.png';
import organ_body_purple from '../../static/images_ae/alkReport/organ_body_purple.png';
import organ_nerve_blue from '../../static/images_ae/alkReport/organ_nerve_blue.png';
import organ_nerve_purple from '../../static/images_ae/alkReport/organ_nerve_purple.png';
import organ_skeleton_blue from '../../static/images_ae/alkReport/organ_skeleton_blue.png';
import organ_skeleton_purple from '../../static/images_ae/alkReport/organ_skeleton_purple.png';
import organ_skin_blue from '../../static/images_ae/alkReport/organ_skin_blue.png';
import organ_skin_purple from '../../static/images_ae/alkReport/organ_skin_purple.png';
import arrow_back from '../../static/images_ae/alkReport/arrow_back.png';
import blue_body from '../../static/images_ae/alkReport/blue_body.png';
import body_organ_shoulder from '../../static/images_ae/alkReport/body_organ_shoulder.png';
import body_organ_blood from '../../static/images_ae/alkReport/body_organ_blood.png';
import body_organ_skeleton from '../../static/images_ae/alkReport/body_organ_skeleton.png';
import body_organ_limbs from '../../static/images_ae/alkReport/body_organ_limbs.png';
import line_to_blood from '../../static/images_ae/alkReport/line_to_blood.png';
import line_to_body from '../../static/images_ae/alkReport/line_to_body.png';
import line_to_nerve from '../../static/images_ae/alkReport/line_to_nerve.png';
import line_to_skin from '../../static/images_ae/alkReport/line_to_skin.png';
import line_to_skeleton from '../../static/images_ae/alkReport/line_to_skeleton.png';
import { withRouter } from 'react-router-dom';
import styles from './others.module.scss';

const api = new ApiCore();

const organMap = {
    'blood': '血液',
    'skin': '皮肤',
    'skeleton': '骨骼肌肉',
    'weight': '体重'
}

const Chest = (props: any) => {

    const [list, setList] = useState<any>([]);
    const [bloodSelected, setBloodSelected] = useState<any>(false);
    const [skinSelected, setSkinSelected] = useState<any>(false);
    const [weightSelected, setWeightSelected] = useState<any>(false);
    const [skeletonSelected, setSkeletonSelected] = useState<any>(false);
    const [fourLimbsSelected, setFourLimbsSelected] = useState<any>(false);
    const [nerveSelected, setNerveSelected] = useState<any>(false);
    const [selectedCount, setSelectedCount] = useState<any>(0);
    const [organs, setOrgans] = useState<any>(props.organs || {});
    const [organList, setOrganList] = useState<any>([]);
    const [symptoms, setSymptoms] = useState<any>([]);
    const [activeOrgan, setActiveOrgan] = useState<any>('blood');
    const [value, setValue] = useState<any>('');
    const [visible, setVisible] = useState<any>(false);
    const [bloodSelectedCount, setBloodSelectedCount] = useState<any>(0);
    const [skinSelectedCount, setSkinSelectedCount] = useState<any>(0);
    const [skeletonSelectedCount, setSkeletonSelectedCount] = useState<any>(0);
    const [weightSelectedCount, setWeightSelectedCount] = useState<any>(0);
    const [nerveSelectedCount, setNerveSelectedCount] = useState<any>(0);

    useEffect(() => {
        window.document.title = 'ALK风险评估';
        initData();
        return () => {
        }
    }, [])

    // useEffect(() => {
    //     let _selectedCount = 0;
    //     [headSelected, chestSelected, stomachSelected, othersSelected, fourLimbsSelected].forEach((val: any) => {
    //         if (val) {
    //             _selectedCount++;
    //         }
    //     })
    //     setSelectedCount(_selectedCount);
    // }, [headSelected, chestSelected, stomachSelected, othersSelected, fourLimbsSelected])

    const initData = () => {
        let _organs = props.organs;
        _organs.organs = _organs.organs.map((vvv: any) => {
            // if (vvv.type === 'lung') {
            //     setBrainIntro(vvv.remark);
            // } else if (vvv.type === 'heart') {
            //     setEyeIntro(vvv.remark);
            // }
            const _lastItem = vvv.symptoms[vvv.symptoms.length -1] || {};
            if (_lastItem && _lastItem.code === '') {
                return vvv;
            } else {
                const symptoms = vvv.symptoms.concat({
                    code: '',
                    name: '其他',
                    organCode: vvv.code
                })
                return {
                    ...vvv,
                    symptoms
                }
            }

        })
        setOrgans(_organs);
        let _list = organs.organs || []
        if (_list) {
            setOrganList(_list);
        }
        // 还原选中状态
        setOrganSelectedActive(_list);
        props.onComplete('body', _list);
    }

    const headSelect = () => {
        setSkeletonSelected(false);
        setWeightSelected(false);
        setSkinSelected(false);
        setBloodSelected(true);
        setNerveSelected(false);
        setActiveOrgan('blood');
    }

    const chestSelect = () => {
        setSkeletonSelected(false);
        setWeightSelected(false);
        setSkinSelected(true);
        setBloodSelected(false);
        setNerveSelected(false);
        setActiveOrgan('skin');
    }

    const stomachSelect = () => {
        setSkeletonSelected(true);
        setWeightSelected(false);
        setSkinSelected(false);
        setBloodSelected(false);
        setNerveSelected(false);
        setActiveOrgan('skeleton');
    }

    const othersSelect = () => {
        setSkeletonSelected(false);
        setWeightSelected(true);
        setSkinSelected(false);
        setBloodSelected(false);
        setNerveSelected(false);
        setActiveOrgan('weight');
    }

    const nerveSelect = () => {
        setSkeletonSelected(false);
        setWeightSelected(false);
        setSkinSelected(false);
        setBloodSelected(false);
        setNerveSelected(true);
        setActiveOrgan('nerve');
    }


    const fourLimbsSelect = () => {
        setFourLimbsSelected(!fourLimbsSelected);
    }

    const symptomsSelected = (val: any, key: number) => {
        if (!val.code) {
            // 其他选项输入
            organList.some((val: any, key: number) => {
                if (activeOrgan === val.type) {
                    const _lastItem = val.symptoms[val.symptoms.length -1] || {};
                    if (_lastItem && _lastItem.code === '') {
                        setValue(_lastItem.value || '');
                        return true;
                    }
                }
            })
            setVisible(true);
            return;
        }
        let _bloodCount = 0;
        let _skinCount = 0;
        let _skeletonCount = 0;
        let _weightCount = 0;
        let _nerveCount = 0;
        const _list = organList.map((item: any) => {
            let _symptoms: any = item.symptoms.map((v: any) => {
                let _selected = !!v.selected;
                if (val.code === v.code) {
                    _selected = !v.selected;
                }
                if (item.type === 'blood') {
                    // 输入其他时
                    if (!v.code) {
                        if (v.value) {
                            _selected = true;
                        } else {
                            _selected = false;
                        }
                    }
                    if (_selected) {
                        _bloodCount++;
                    }
                } else if (item.type === 'skin') {
                    // 输入其他时
                    if (!v.code) {
                        if (v.value) {
                            _selected = true;
                        } else {
                            _selected = false;
                        }
                    }
                    if (_selected) {
                        _skinCount++;
                    }
                } else if (item.type === 'skeleton') {
                    // 输入其他时
                    if (!v.code) {
                        if (v.value) {
                            _selected = true;
                        } else {
                            _selected = false;
                        }
                    }
                    if (_selected) {
                        _skeletonCount++;
                    }
                } else if (item.type === 'weight') {
                    // 输入其他时
                    if (!v.code) {
                        if (v.value) {
                            _selected = true;
                        } else {
                            _selected = false;
                        }
                    }
                    if (_selected) {
                        _weightCount++;
                    }
                } else if (item.type === 'nerve') {
                    // 输入其他时
                    if (!v.code) {
                        if (v.value) {
                            _selected = true;
                        } else {
                            _selected = false;
                        }
                    }
                    if (_selected) {
                        _nerveCount++;
                    }
                }
                return {
                    ...v,
                    selected: _selected
                }
            });
            return {
                ...item,
                symptoms: _symptoms
            }
            // let selected = !!item.selected;
            // if (val.code === item.code) {
            //     selected = true;
            // }
            // return {
            //     selected: selected,
            //     ...item
            // }
        });
        // let _bloodCount = 0;
        // let _skinCount = 0;
        // let _skeletonCount = 0;
        // let _weightCount = 0;
        setBloodSelected(_bloodCount > 0);
        setSkinSelected(_skinCount > 0);
        setSkeletonSelected(_skeletonCount > 0);
        setWeightSelected(_weightCount > 0);
        setNerveSelected(_nerveCount > 0);
        setBloodSelectedCount(_bloodCount);
        setSkinSelectedCount(_skinCount);
        setSkeletonSelectedCount(_skeletonCount);
        setWeightSelectedCount(_weightCount);
        setNerveSelectedCount(_nerveCount);
        setOrganList(_list);
        const _organs = organs;
        _organs.organs = _list;
        setOrgans(_organs)
        props.onComplete('body', _list);
    }
    
    const setOrganSelectedActive = (mOrganList?: any) => {
        let _bloodCount = 0;
        let _skinCount = 0;
        let _skeletonCount = 0;
        let _weightCount = 0;
        let _nerveCount = 0;
        let _organList = mOrganList || organList;
        _organList.forEach((item: any) => {
            item.symptoms.forEach((v: any) => {
                let _selected = v.selected;
                if (item.type === 'blood') {
                    if (_selected) {
                        _bloodCount++;
                    }
                } else if (item.type === 'skin') {
                    if (_selected) {
                        _skinCount++;
                    }
                } else if (item.type === 'skeleton') {
                    if (_selected) {
                        _skeletonCount++;
                    }
                } else if (item.type === 'weight') {
                    if (_selected) {
                        _weightCount++;
                    }
                } else if (item.type === 'nerve') {
                    if (_selected) {
                        _nerveCount++;
                    }
                }
            });
        });
        setBloodSelected(_bloodCount > 0);
        setSkinSelected(_skinCount > 0);
        setSkeletonSelected(_skeletonCount > 0);
        setWeightSelected(_weightCount > 0);
        setNerveSelected(_nerveCount > 0);
        setBloodSelectedCount(_bloodCount);
        setSkinSelectedCount(_skinCount);
        setSkeletonSelectedCount(_skeletonCount);
        setWeightSelectedCount(_weightCount);
        setNerveSelectedCount(_nerveCount);
    }

    const setOtherValue = (value: any) => {
        let _organs = organs;
        _organs.organs = _organs.organs.map((vvv: any) => {
            const _lastItem = vvv.symptoms[vvv.symptoms.length -1] || {};
            if (_lastItem && _lastItem.code === '') {
                const symptoms = vvv.symptoms.map((vv: any) => {
                    if (activeOrgan === vvv.type && vv.code === '') {
                        let selected = !!value;
                        return {
                            code: '',
                            name: '其他',
                            value: value,
                            selected: selected,
                            organCode: vv.organCode
                        }
                    } else {
                        return vv;
                    }

                })
                return {
                    ...vvv,
                    symptoms
                }
            } else {
                return vvv;
            }

        })
        setOrgans(_organs)
        let _list = _organs.organs || []
        if (_list) {
            setOrganList(_list);
        }
        return _list;
    }

    return (
        <div className={styles.ae_reporting}>
            {/* <div className={styles.tip_top_wrap}>
                <img className={styles.tip_top} src={tip_top_select} alt="" />
                <div className={styles.tip_top_text}>请从下列5个部位中选择您出现不适的部位</div>
            </div> */}
            <div className={styles.choose_symptom}>
                <div className={styles.content_area}>
                    <div className={styles.sympton_title}>ALK肺癌患者常见风险症状：</div>
                    <div className={styles.sympton_content}>
                        {
                            organList.map((val: any, key: number) => {
                                if (activeOrgan === val.type) {
                                    return val.symptoms.map((val: any, iKey: number) => (
                                        <div key={iKey} className={`${val.selected ? styles.active : styles.un_active}`} onClick={() => { symptomsSelected(val, key) }}>{val.name}</div>
                                    ))
                                }
                            })
                        }
                    </div>
                </div>
            </div>
            <div className={styles.body_title}>
                <div className={styles.body_active}>
                    全部
                </div>
                <div className={styles.body_active}>
                    全身
                </div>
                <div className={styles.body_un_active}>{ organMap[activeOrgan] || '未选器官'}</div>
            </div>
            <div className={styles.area_body_container}>
                <img className={styles.body_organ_shoulder} src={body_organ_shoulder} alt="" />
                <img className={styles.body_organ_blood} src={body_organ_blood} alt="" />
                <img className={styles.area_body} src={blue_body} alt="" />
                <img className={styles.body_organ_skeleton} src={body_organ_skeleton} alt="" />
                <img className={styles.body_organ_limbs} src={body_organ_limbs} alt="" />
                <div className={`${styles.area_base} ${styles.area_head} ${bloodSelected ? styles.area_active : styles.area_in_active}`} onClick={ () => { headSelect()} }>
                    <div className={`${styles.area_tl_l}`}></div>
                    <div className={`${styles.area_tl_t}`}></div>
                    <div className={`${styles.area_tr_r}`}></div>
                    <div className={`${styles.area_tr_t}`}></div>
                    <div className={`${styles.area_bl_l}`}></div>
                    <div className={`${styles.area_bl_b}`}></div>
                    <div className={`${styles.area_br_r}`}></div>
                    <div className={`${styles.area_br_b}`}></div>

                    <div className={styles.area_head_top}>
                        <img className={styles.icon_blood} src={bloodSelected ? organ_blood_blue : organ_blood_purple} alt="" />
                        <div>血液</div>
                        {
                            bloodSelectedCount > 0 &&
                            <div className={styles.symptom}>
                                {bloodSelectedCount}
                                <div className={`${styles.area_tr_r}`}></div>
                                <div className={`${styles.area_tr_t}`}></div>
                            </div>
                        }
                    </div>
                    {/* <div className={styles.area_head_middle}>
                    </div>
                    <div className={styles.area_head_bottom}>
                        包括精神方面、五官等部位
                    </div> */}
                    {/* <img  className={styles.line_head} src={line_to_blood} alt="" /> */}
                </div>
                <div className={`${styles.area_base} ${styles.area_chest} ${skinSelected ? styles.area_active : styles.area_in_active}`} onClick={ () => { chestSelect()} }>
                    <div className={`${styles.area_tl_l}`}></div>
                    <div className={`${styles.area_tl_t}`}></div>
                    <div className={`${styles.area_tr_r}`}></div>
                    <div className={`${styles.area_tr_t}`}></div>
                    <div className={`${styles.area_bl_l}`}></div>
                    <div className={`${styles.area_bl_b}`}></div>
                    <div className={`${styles.area_br_r}`}></div>
                    <div className={`${styles.area_br_b}`}></div>
                    <div className={styles.area_head_top}>
                        <img className={styles.icon_skin} src={skinSelected ? organ_skin_blue : organ_skin_purple} alt="" />
                        <div>皮肤</div>
                        {
                            skinSelectedCount > 0 &&
                            <div className={styles.symptom}>
                                {skinSelectedCount}
                                <div className={`${styles.area_tr_r}`}></div>
                                <div className={`${styles.area_tr_t}`}></div>
                            </div>
                        }
                    </div>
                    {/* <div className={styles.area_head_middle}>
                    </div>
                    <div className={styles.area_head_bottom}>
                        包括心脏、肺部等器官
                    </div> */}
                    {/* <img  className={styles.line_chest} src={line_to_skin} alt="" /> */}
                </div>
                <div className={`${styles.area_base} ${styles.area_stomach} ${skeletonSelected ? styles.area_active : styles.area_in_active}`} onClick={ () => { stomachSelect()} }>
                    <div className={`${styles.area_tl_l}`}></div>
                    <div className={`${styles.area_tl_t}`}></div>
                    <div className={`${styles.area_tr_r}`}></div>
                    <div className={`${styles.area_tr_t}`}></div>
                    <div className={`${styles.area_bl_l}`}></div>
                    <div className={`${styles.area_bl_b}`}></div>
                    <div className={`${styles.area_br_r}`}></div>
                    <div className={`${styles.area_br_b}`}></div>

                    <div className={styles.area_head_top}>
                        <img className={styles.icon_skeleton} src={skeletonSelected ? organ_skeleton_blue : organ_skeleton_purple} alt="" />
                        <div>骨骼肌肉</div>
                        {
                            skeletonSelectedCount > 0 &&
                            <div className={styles.symptom}>
                                {skeletonSelectedCount}
                                <div className={`${styles.area_tr_r}`}></div>
                                <div className={`${styles.area_tr_t}`}></div>
                            </div>
                        }
                    </div>
                    {/* <div className={styles.area_head_middle}>
                    </div>
                    <div className={styles.area_head_bottom}>
                        包括心脏、肺部等器官
                    </div> */}
                    {/* <img  className={styles.line_stomach} src={line_to_skeleton} alt="" /> */}
                </div>
                <div className={`${styles.area_base} ${styles.area_others} ${weightSelected ? styles.area_active : styles.area_in_active}`} onClick={ () => { othersSelect()} }>
                    <div className={`${styles.area_tl_l}`}></div>
                    <div className={`${styles.area_tl_t}`}></div>
                    <div className={`${styles.area_tr_r}`}></div>
                    <div className={`${styles.area_tr_t}`}></div>
                    <div className={`${styles.area_bl_l}`}></div>
                    <div className={`${styles.area_bl_b}`}></div>
                    <div className={`${styles.area_br_r}`}></div>
                    <div className={`${styles.area_br_b}`}></div>
                    <div className={styles.area_head_top}>
                        <img className={styles.icon_body} src={weightSelected ? organ_body_blue : organ_body_purple} alt="" />
                        <div>体重</div>
                        {
                            weightSelectedCount > 0 &&
                            <div className={styles.symptom}>
                                {weightSelectedCount}
                                <div className={`${styles.area_tr_r}`}></div>
                                <div className={`${styles.area_tr_t}`}></div>
                            </div>
                        }
                    </div>
                    {/* <div className={styles.area_head_middle}>
                    </div>
                    <div className={styles.area_head_bottom}>
                        包括心脏、肺部等器官
                    </div> */}
                    {/* <img  className={styles.line_others} src={line_to_body} alt="" /> */}
                </div>
                <div className={`${styles.area_base} ${styles.area_nerve} ${nerveSelected ? styles.area_active : styles.area_in_active}`} onClick={ () => { nerveSelect()} }>
                    <div className={`${styles.area_tl_l}`}></div>
                    <div className={`${styles.area_tl_t}`}></div>
                    <div className={`${styles.area_tr_r}`}></div>
                    <div className={`${styles.area_tr_t}`}></div>
                    <div className={`${styles.area_bl_l}`}></div>
                    <div className={`${styles.area_bl_b}`}></div>
                    <div className={`${styles.area_br_r}`}></div>
                    <div className={`${styles.area_br_b}`}></div>
                    <div className={styles.area_head_top}>
                        <img className={styles.icon_nerve} src={nerveSelected ? organ_nerve_blue : organ_nerve_purple} alt="" />
                        <div>周围神经</div>
                        {
                            nerveSelectedCount > 0 &&
                            <div className={styles.symptom}>
                                {nerveSelectedCount}
                                <div className={`${styles.area_tr_r}`}></div>
                                <div className={`${styles.area_tr_t}`}></div>
                            </div>
                        }
                    </div>
                    {/* <img  className={styles.line_nerve} src={line_to_nerve} alt="" /> */}
                </div>
                <div onClick={() => { props.onBack() }} className={`${styles.area_base} ${styles.area_four_limbs} ${fourLimbsSelected ? styles.area_active : styles.area_in_active}`}>
                    <div className={`${styles.area_tl_l}`}></div>
                    <div className={`${styles.area_tl_t}`}></div>
                    <div className={`${styles.area_tr_r}`}></div>
                    <div className={`${styles.area_tr_t}`}></div>
                    <div className={`${styles.area_bl_l}`}></div>
                    <div className={`${styles.area_bl_b}`}></div>
                    <div className={`${styles.area_br_r}`}></div>
                    <div className={`${styles.area_br_b}`}></div>
                    <div className={styles.area_head_top}>
                        <img className={styles.icon_head} src={arrow_back} alt="" />
                        <div>返回</div>
                    </div>
                </div>
            </div>

            {/* <div className={styles.sympton_select}>
                <div className={styles.sympton_select_img_wrap}>
                    <img src={sympton_bg} alt="" />
                </div>
                <div className={styles.sympton_select_text_wrap}>
                    <div className={styles.sympton_select_text}>请选择一个或多个与您症状贴近的病症描述：</div>
                    <div className={styles.sympton_select_menu}>
                    {
                        organList.map((val: any, key: number) => {
                            if (activeOrgan === val.type) {
                                return val.symptoms.map((val: any, iKey: number) => (
                                    <div key={iKey} className={`${val.selected ? styles.menu_active : ''}`} onClick={() => { symptomsSelected(val, key) }}>{val.name}</div>
                                ))
                            }
                        })
                    }
                    </div>
                </div>
            </div> */}
            {/* <div className={styles.btns_wrap}>
                <div className={styles.btns_back}>
                    <img className={styles.bootom_top} src={bg_back} alt="" />
                    <div className={styles.text} onClick={() => { props.onBack() }}>返回上一步</div>
                </div>
                <div className={styles.btns_finish_go_on}>
                    <img className={styles.bootom_top} src={bg_finish_go_on} alt="" />
                    <div className={styles.text} onClick={() => { props.onComplete('body', organList) }}>选择完成，继续评测</div>
                </div>
            </div> */}
            <Modal
                visible={visible}
                content={
                    <TextArea
                        placeholder='请输入内容'
                        value={value}
                        onChange={val => {
                            setValue(val)
                        }}
                    />
                }
                // closeOnMaskClick
                closeOnAction
                onClose={() => {
                    setOrganSelectedActive(setOtherValue(value));
                    setVisible(false)
                }}
                actions={[
                    {
                        key: 'confirm',
                        text: '确定',
                    },
                ]}
            >
            </Modal>
        </div>
    )
}

export default withRouter(Chest);